import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Chip,
  Stack,
  Tooltip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckIcon from "@mui/icons-material/Check";
import { Info } from "lucide-react";

const FeatureList = ({ planFeatures, allFeatures, isPremium }) => {
  const planFeatureIds = planFeatures?.map((f) => f.featureId);

  const renderTooltipContent = ({ details }) => {
    // Safety check: if no details, return null
    if (!details) return null;

    const items = details
      .split("~")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);

    // Safety check: if splitting results in no items, return null
    if (items.length === 0) return null;

    return (
      <Box sx={{ p: 0.5 }}>
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              // Add small margin between items, but not after the last one
              mb: index < items.length - 1 ? 0.5 : 0,
            }}
          >
            {/* Changed color to white for visibility on dark background */}
            <CheckIcon sx={{ fontSize: 12, color: "#fff" }} />

            {/* Changed color to white and used Typography for consistency */}
            <Typography
              variant="caption"
              sx={{ color: "#fff", lineHeight: 1.4 }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  };

  const renderAdditionalFeatureList = (details) => {
    if (!details) return null;

    const items = details
      .split("~")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);

    if (items.length === 0) return null;

    return (
      <Box
        component="ul"
        sx={{
          m: 0,
          p: 0,
          ml: 3,
          pl: 2,
          listStyleType: "disc",
          listStylePosition: "inside",
        }}
      >
        {items.map((item, index) => (
          <Typography
            component="li"
            key={index}
            variant="body2"
            sx={{
              mb: 0.5,
              color: "text.secondary",
            }}
          >
            {item}
          </Typography>
        ))}
      </Box>
    );
  };

  return (
    <>
      {allFeatures.map((feature) => {
        const isIncluded = planFeatureIds.includes(feature.featureID);
        const planFeature = planFeatures.find(
          (f) => f.featureId === feature.featureID,
        );

        return (
          <Box key={feature.featureId} sx={{ mb: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                opacity: isIncluded ? 1 : 0.4,
                textDecoration: isIncluded ? "none" : "line-through",
              }}
            >
              {/* {JSON.stringify(planFeature)} */}
              <CheckIcon
                sx={{
                  fontSize: 14,
                  color: isIncluded ? "#371b17" : "gray",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: isIncluded ? "text.primary" : "gray",
                }}
              >
                {planFeature?.displayLabel
                  ? planFeature?.displayLabel
                  : feature.displayName}{" "}
              </Typography>

              {planFeature?.typeHint === "info" &&
                planFeature?.featureDetails && (
                  <Tooltip
                    title={renderTooltipContent({
                      details: planFeature.featureDetails,
                    })}
                    arrow
                    placement="top"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "rgba(0, 0, 0, 0.9)",
                          color: "white",
                          maxWidth: 300,
                        },
                      },
                    }}
                  >
                    <Box component="span">
                      <Info size={16} style={{ cursor: "pointer" }} />
                    </Box>
                  </Tooltip>
                )}
            </Box>

            {planFeature?.typeHint !== "info" &&
              planFeature?.featureDetails &&
              renderAdditionalFeatureList(planFeature.featureDetails)}
          </Box>
        );
      })}
    </>
  );
};
export default FeatureList;
